import React from 'react';
import BiddingDetails from 'components/BiddingDetails';
import BiddingForwardDetails from 'components/BiddingForwardDetails';
import BiddingForeignDetails from 'components/BiddingForeignDetails';

const BiddingDemandDetails = ({ id, bidType, bidDemandType }) => {
  return (
    <div className="bidding-detail-mobile">
      {' '}
      {bidDemandType === 'FORWARD' && (
        <BiddingForwardDetails
          id={id}
          bidType={bidType}
          bidOfferAndDemandType={bidDemandType}
        />
      )}
      {bidDemandType === 'LIVE' && (
        <BiddingDetails
          id={id}
          bidType={bidType}
          bidOfferAndDemandType={bidDemandType}
        />
      )}
      {bidDemandType === 'FOREIGN' && (
        <BiddingForeignDetails
          id={id}
          bidType={bidType}
          bidOfferAndDemandType={bidDemandType}
        />
      )}
    </div>
  );
};

export default BiddingDemandDetails;
